import {
  getGetOwnerPortalStatementPdfUrl,
  useListOwnerPortalStatements,
  type StatementOut,
} from '@myrentalmate/api-client';
import { Alert, Button, Stack, Typography } from '@mui/material';

import { DataTable, type DataColumn } from '../../components/DataTable';
import { TablePager, useTablePage } from '../../components/TablePager';
import { okItems } from '../../lib/apiData';
import { formatMoney, formatMonth } from '../../lib/format';
import { OwnerNotLinked } from './OwnerNotLinked';
import { useOwnerHome } from './useOwnerHome';

const COLUMNS: DataColumn<StatementOut>[] = [
  { label: 'Month', render: (s) => formatMonth(s.period) },
  { label: 'Collected', align: 'right', render: (s) => formatMoney(s.receipts) },
  { label: 'Expenses', align: 'right', render: (s) => formatMoney(s.expenses) },
  { label: 'Fees', align: 'right', render: (s) => formatMoney(s.fees) },
  { label: 'Paid to You', align: 'right', render: (s) => formatMoney(s.distributions) },
  { label: 'Balance', align: 'right', render: (s) => formatMoney(s.closing) },
  {
    label: 'PDF',
    align: 'right',
    render: (s) =>
      s.id !== null && (
        <Button size="small" href={getGetOwnerPortalStatementPdfUrl(s.id)}>
          Download
        </Button>
      ),
  },
];

export function OwnerPortalStatementsPage() {
  const { notLinked } = useOwnerHome();
  const statements = okItems(useListOwnerPortalStatements({ query: { retry: false } }).data);
  const paging = useTablePage();
  if (notLinked) return <OwnerNotLinked />;
  const showing = statements.slice(
    paging.page * paging.pageSize,
    (paging.page + 1) * paging.pageSize,
  );
  return (
    <Stack spacing={2}>
      <Typography variant="h5">Statements</Typography>
      <DataTable columns={COLUMNS} rows={showing} rowKey={(s) => s.period} />
      <TablePager paging={paging} total={statements.length} />
      {statements.length === 0 && <Alert severity="info">No statements have been published.</Alert>}
    </Stack>
  );
}
